import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
/**
 * Document title setting component. Sets and announces document title change to screen readers.
 * See further documentation below.
 */

var DocumentTitleManager = function DocumentTitleManager(_ref) {
  var documentTitle = _ref.documentTitle;

  var _useState = useState(documentTitle),
      _useState2 = _slicedToArray(_useState, 2),
      currentDocumentTitleAnnouncement = _useState2[0],
      setCurrentDocumentTitleAnnouncement = _useState2[1];

  useEffect(function () {
    if (typeof documentTitle !== 'undefined' && documentTitle !== '' && document.title !== documentTitle) {
      document.title = documentTitle;
      setCurrentDocumentTitleAnnouncement(documentTitle);
    }
  }, [documentTitle]);
  return /*#__PURE__*/React.createElement("span", {
    key: currentDocumentTitleAnnouncement
  }, currentDocumentTitleAnnouncement);
};

DocumentTitleManager.propTypes = process.env.NODE_ENV !== "production" ? {
  documentTitle: PropTypes.string
} : {};
DocumentTitleManager.defaultProps = {
  documentTitle: ''
};
export default DocumentTitleManager;